import { Controller } from "stimulus"
import Rails from "@rails/ujs"

export default class extends Controller {
  static targets = ['token', 'answerCorrect', 'answerWrong', 'submit' ]

  select(){
    if (event.target.classList.contains('h-token')) {
      event.target.classList.toggle('h-active')

      if (this.isHighlighted) {
        this.submitTarget.classList.remove('d-none')
        this.submitTarget.classList.add('fade-in')
      } else {
        this.submitTarget.classList.add('d-none')
      }
    }
  }

  check(){
    let correct = true

    this.tokenTargets.forEach((token) => {
      if (token.dataset.flag === 'c') {
        token.classList.add('h-correct')
        if (!token.classList.contains('h-active')) {
          correct = false
        }
      } else if (token.classList.contains('h-active')) {
        token.classList.add('h-wrong')
        correct = false
      }
      token.classList.remove('h-token')
    })

    this.element.dataset.answer = (correct ? 'correct' : 'wrong')
    Rails.fire(this.element, 'traininganswered')

    this.answerCorrectTarget.classList.toggle('d-none', !correct)
    this.answerWrongTarget.classList.toggle('d-none', correct)

    this.submitTarget.classList.add('d-none')
  }

  get isHighlighted() {
    return this.selectedTokens.length > 0
  }

  get selectedTokens() {
    return this.tokenTargets.filter((token) => {
      return token.classList.contains('h-active')
    })
  }
}
